import { GtmProductType } from '~/models/Product/GtmProductType'

interface ProductTypeSource {
    labTest?: unknown | null
    marketPlaceData?: unknown | null
    unilabsReservations?: unknown[]
    marketPlaceInfo?: unknown | null
}

// Product/FullProduct expose `labTest` and `marketPlaceData`; BasketProduct uses different field
// names (`unilabsReservations`, `marketPlaceInfo`) for the same distinction - check both.
export const resolveGtmProductType = (product: ProductTypeSource): GtmProductType => {
    if (product.labTest || (product.unilabsReservations?.length ?? 0) > 0) {
        return GtmProductType.LabTest
    }

    if (product.marketPlaceData || product.marketPlaceInfo) {
        return GtmProductType.Marketplace
    }

    return GtmProductType.Normal
}
